import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import FunFact from '../FunFact';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import TeamSlider from '../Slider/TeamSlider';
import Spacing from '../Spacing';
const funfaceData = [
  {
    title: 'Brands Transformed',
    factNumber: '100',
  },
  {
    title: 'Creative Minds Fueling Innovation',
    factNumber: '20',
  },
  {
    title: 'Projects Crafted to Perfection',
    factNumber: '200',
  },
  {
    title: 'Digital Products Shaping the Future',
    factNumber: '50',
  },
];

export default function AboutPage() {
  pageTitle('About');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title="About Us"
        bgSrc="images/about_hero_bg.jpeg"
        pageLinkText="About Us"
      />
      {/* End Page Heading Section */}

      {/* Start About Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7">
            <SectionHeading
              title="Redefining Creativity &nbsp; & Innovation"
              subtitle="Inside Our Creative Universe"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Every brand has a story, let’s make yours unforgettable.. We don’t just create; we innovate, disrupt, and elevate. From bold branding to cutting-edge tech, dynamic content to digital dominance, we craft solutions that fuel growth. Let’s build something extraordinary together.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2">
            <img
              src="/images/about_img_3.JPG"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7">
            <img
              src="/images/about_img_5.png"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5">
            <img
              src="/images/about_img_2.png"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      {/* End About Section */}

      {/* Start Fun Fact Section */}
      <Div className="container">
        <FunFact
          title="Our Creative Code"
          subtitle="Creativity isn’t just what we do, it’s who we are. We decode challenges, engineer innovations, and craft future-ready solutions that transform ideas into impact. "
          data={funfaceData}
        />
      </Div>
      {/* End Fun Fact Section */}

      {/* Start Why Choose Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_4.jpeg"
                  alt="About"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Innovators at Heart, Problem-Solvers in Action"
              subtitle="The Power Behind Your Growth"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                At Just Charge, your vision fuels our innovation. We don’t just solve problems, we ignite possibilities. With a 360° approach across branding, tech, media, and design, we craft solutions that nitroboost your growth.

              </p>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                Whether it’s building cutting-edge digital experiences, creating high-impact content, or designing game-changing strategies, we ensure every step is bold, data-driven, and built for your success. Let’s disrupt, innovate, and take your brand to the next level together.              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End Why Choose Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Meet Our Rockstars"
          subtitle="Creators, Innovators & Game-Changers "
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      {/* End Team Section */}

      {/* Start CTA Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together! "
          btnText="Your Next Big Move Starts Here!"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
